






























































import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import {
  IWorkflowFormTemplateRevision,
  WorkflowFormTemplateStateEnum,
  IWorkflowFormTemplateRevisionStatus
} from '@/models';
import { ErrorManager } from '@/models/error';

import { colors, classToHex } from '@/utils/colorUtils';

import auth from '@/mixins/auth';

import Proxyable from '@/mixins/proxyable';
import mixins from '@/utils/mixins';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import WorkflowFormSubmissionDialog from '@/components/workflow-form/WorkflowFormSubmissionDialog.vue';

const baseMixins = mixins(auth, Proxyable);

interface Options extends InstanceType<typeof baseMixins> {
  /* eslint-disable-next-line camelcase */
  $refs: {
    workflowFormSubmissionDialog: InstanceType<
      typeof WorkflowFormSubmissionDialog
    >;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'WorkflowFormBuilderDetailStateCard',

    components: {
      ConfirmationDialog,
      ErrorAlert,
      WorkflowFormSubmissionDialog
    },

    props: {
      value: {
        type: Object as PropType<IWorkflowFormTemplateRevision>
      }
    },

    data: () => ({
      WorkflowFormTemplateStateEnum,
      loading: false,

      errorMessage: '',
      errorMessageDetail: ''
    }),

    computed: {
      ...mapGetters({
        getWorkflowFormTemplateRevisionById:
          'workflowFormTemplate/getWorkflowFormTemplateRevisionById'
      }),

      formTemplateRevisionId(): number {
        return Number(this.$route.params.revisionId);
      },

      workflowFormTemplateRevision(): IWorkflowFormTemplateRevision {
        return this.getWorkflowFormTemplateRevisionById(
          this.formTemplateRevisionId
        );
      },

      getStatusIcon(): string {
        return (this.workflowFormTemplateRevision
          .state as IWorkflowFormTemplateRevisionStatus).getCurrentState()
          .icon!;
      },

      getStatusMessage(): string {
        return (this.workflowFormTemplateRevision
          .state as IWorkflowFormTemplateRevisionStatus).getCurrentState()
          .display_name!;
      },

      getStatusColor(): string {
        return (this.workflowFormTemplateRevision
          .state as IWorkflowFormTemplateRevisionStatus).getCurrentState()
          .color!;
      },

      getStatusHexColor(): string {
        return classToHex(
          (this.workflowFormTemplateRevision
            .state as IWorkflowFormTemplateRevisionStatus).getCurrentState()
            .color!,
          colors,
          this.$vuetify.theme.currentTheme
        );
      }
    },

    methods: {
      ...mapActions({
        updateWorkflowFormTemplateRevisionState:
          'workflowFormTemplate/updateWorkflowFormTemplateRevisionState'
      }),

      openPreviewForm() {
        this.$refs.workflowFormSubmissionDialog.open(
          this.workflowFormTemplateRevision,
          undefined,
          true
        );
      },

      updateState(state: WorkflowFormTemplateStateEnum) {
        this.loading = true;
        this.updateWorkflowFormTemplateRevisionState({
          templateId: this.workflowFormTemplateRevision.template!.id,
          revisionId: this.workflowFormTemplateRevision.id,
          state: state
        })
          .then(() => {
            this.$emit('updated-state');
          })
          .catch(error => {
            if (error.response && error.response.data.detail) {
              this.errorMessageDetail = error.response.data.detail;
            }
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  });
